/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * config.js
 */

export default class Config {
    static OAUTH_API_URL: string = process.env.REACT_APP_OAUTH_HOST || ""
    static KAREVI_API_URL: string = process.env.REACT_APP_API_HOST || ""
    static OAUTH_REDIRECT_URI: string = process.env.REACT_APP_OAUTH_REDIRECT_URI || ""
    static API_CLIENT_ID: string = process.env.REACT_APP_CLIENT_ID || ""
    static API_CLIENT_SECRET: string = process.env.REACT_APP_CLIENT_SECRET || ""
    static APP_NAME: string = process.env.REACT_APP_NAME || ""
    static OAUTH_CLIENT_ID: string = process.env.REACT_APP_OAUTH_CLIENT_ID || ""
}